import React from 'react';
import PropTypes from 'prop-types';

import {
  ReferenceField,
  useRecordContext,
  TextField,
  FunctionField,
  TextFieldProps,
  usePermissions,
} from 'react-admin';

import LinkField from '../components/layout/LinkField';
import { useScopedEmbeddedViewContext } from '../components/utils/ScopedEmbeddedViewContext';
import actions, { Actions } from '../constants/actions';
import hasAccess from '../utilities/hasAccess';
import PermissionMissing from '../components/utils/PermissionMissing';
import resourceNames from '../constants/resourceNames';

const ReferenceMemberField = ({ label, noLink }: Omit<TextFieldProps, 'source'> & {noLink?: boolean}) => {
  const record = useRecordContext();
  const scope = useScopedEmbeddedViewContext();
  const shouldLink = !scope.isScopedEmbedded && !noLink;
  const { permissions } = usePermissions<Actions[]>();

  if (record?.authenticator.type === 'ApiKey') {
    return (
      hasAccess(permissions, actions.API_KEY_LIST) ? (
        <ReferenceField label={label} source="authenticator.id" reference={resourceNames.API_KEYS} link={shouldLink && 'show'}>
          <LinkField source="clientId" />
        </ReferenceField>
      ) : (<PermissionMissing />)
    );
  }

  if (record?.authenticator.type === 'Member') {
    return (
      hasAccess(permissions, actions.MEMBER_LIST) ? (
        <ReferenceField label={label} source="authenticator.id" reference={resourceNames.MEMBERS} link={shouldLink && 'edit'}>
          <FunctionField
            render={(member: {firstName: string; lastName: string}) => `${member.firstName} ${member.lastName}`}
          />
        </ReferenceField>
      ) : (<PermissionMissing />)
    );
  }

  return (
    <TextField emptyText="System" label={label} source="_nonExistingField" />
  );
};

ReferenceMemberField.defaultProps = {
  addLabel: true,
};

ReferenceMemberField.propTypes = {
  addLabel: PropTypes.bool,
};

export default ReferenceMemberField;
